import { render } from "./Main-page.vue?vue&type=template&id=c547bf34&scoped=true"
import script from "./Main-page.vue?vue&type=script&lang=js"
export * from "./Main-page.vue?vue&type=script&lang=js"

import "./Main-page.vue?vue&type=style&index=0&id=c547bf34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c547bf34"]])

export default __exports__